import genericMemo from "Common/componentUtils/genericMemo";
import withPopover from "Components/withPopover";
import omit from "lodash/omit";
import React from "react";
import Button from "./button";
const ButtonWithPopover = withPopover((props) => (React.createElement(Button, { ...omit(props, ["width", "height"]), height: props.buttonHeight, width: props.buttonWidth })));
export default genericMemo(ButtonWithPopover);
